import React, { useState, useEffect } from 'react';
import VacancyDetail from '../../services/vacancy.service';
import './VacancyDetails.css'; // Adjust the path if necessary

const VacancyDetails = () => {
  const [vacancies, setVacancies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(7);
  const [selectedVacancy, setSelectedVacancy] = useState(null); // State for selected vacancy
  const token = localStorage.getItem('token'); // Check if user is logged in

  useEffect(() => {
    const fetchVacancies = async () => {
      try {
        const data = await VacancyDetail.getAllVacancies(token);
        const currentDate = new Date();
        
        // Filter vacancies to only include those whose end date has not passed
        const activeVacancies = data.data.filter(vacancy => new Date(vacancy.end_date) >= currentDate);
        
        setVacancies(activeVacancies);
      } catch (error) {
        console.error('Error fetching vacancies:', error);
      }
    };
    fetchVacancies();
  }, [token]);

  // Calculate the index of the last and first record on the current page
  const indexOfLastRecord = Math.min(currentPage * recordsPerPage, vacancies.length);
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  // Get the records to display on the current page
  const currentRecords = vacancies.slice(indexOfFirstRecord, indexOfLastRecord);

  // Calculate the total number of pages
  const totalPages = Math.ceil(vacancies.length / recordsPerPage);

  // Render the pagination buttons
  const renderPagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return (
      <div className="pagination">
        {pageNumbers.map((pageNumber) => (
          <button
            key={pageNumber}
            className={currentPage === pageNumber ? 'active' : ''}
            onClick={() => setCurrentPage(pageNumber)}
          >
            {pageNumber}
          </button>
        ))}
      </div>
    );
  };

  // Handle vacancy selection
  const handleVacancyClick = (vacancy) => {
    setSelectedVacancy(vacancy);
  };

  // Close the modal
  const closeModal = () => {
    setSelectedVacancy(null);
  };

  // Handle edit action
  const handleEdit = () => {
    // Implement edit functionality, e.g., navigate to an edit form
    console.log('Edit vacancy:', selectedVacancy);
    // Example: navigate(`/edit/${selectedVacancy.vacancy_id}`);
  };

  // Handle delete action
  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this vacancy?')) {
      try {
        await VacancyDetail.deleteVacancy(selectedVacancy.vacancy_id, token); // Adjust this method as needed
        setVacancies(vacancies.filter(vacancy => vacancy.vacancy_id !== selectedVacancy.vacancy_id));
        closeModal();
      } catch (error) {
        console.error('Error deleting vacancy:', error);
      }
    }
  };

  return (
    <div className="table-container">
      {vacancies.length > 0 ? (
        <div>
          <table>
            <thead>
              <tr>
                <th>Vacancy ID</th>
                <th>Title</th>
                <th>Description</th>
                <th>Location</th>
                <th>Salary</th>
                <th>Job Type</th>
                <th>Requirements</th>
                <th>Link</th>
                <th>Posted Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.map((vacancy, index) => (
                <tr key={vacancy.vacancy_id} onClick={() => handleVacancyClick(vacancy)}>
                  <td>{index + 1}</td>
                  <td>{vacancy.title}</td>
                  <td>{vacancy.description}</td>
                  <td>{vacancy.location}</td>
                  <td>{vacancy.salary}</td>
                  <td>{vacancy.job_type}</td>
                  <td>{vacancy.requirements}</td>
                  <td><a href={vacancy.link}>{vacancy.link}</a></td>
                  <td>{new Date(vacancy.posted_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
                  <td>{new Date(vacancy.end_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {renderPagination()}
        </div>
      ) : (
        <h1 className='no-vacancy'>No Vacancy</h1>
      )}

      {/* Modal for displaying vacancy details */}
      {selectedVacancy && (
        <div className="modal">
          <div className="modal-content">
            <h2>Vacancy Details</h2>
            <p><strong>Title:</strong> {selectedVacancy.title}</p>
            <p><strong>Description:</strong> {selectedVacancy.description}</p>
            <p><strong>Location:</strong> {selectedVacancy.location}</p>
            <p><strong>Salary:</strong> {selectedVacancy.salary}</p>
            <p><strong>Job Type:</strong> {selectedVacancy.job_type}</p>
            <p><strong>Requirements:</strong> {selectedVacancy.requirements}</p>
            <p><strong>Link:</strong> <a href={selectedVacancy.link}>{selectedVacancy.link}</a></p>
            <p><strong>Posted Date:</strong> {new Date(selectedVacancy.posted_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
            <p><strong>End Date:</strong> {new Date(selectedVacancy.end_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
            {token && ( // Show edit and delete buttons only if the user is logged in
              <div>
                <button onClick={handleEdit}>Edit</button>
                <button onClick={handleDelete}>Delete</button>
              </div>
            )}
            <button onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VacancyDetails;